import ContactsIcon                             from '@/assets/icons/ContactsIcon';
import List                                     from '@/components/list/List';
import { useTranslation }                       from 'react-i18next';
import RelationRequestTargetResponseModel       from '@/models/services/network/RelationRequestTargetResponseModel';
import RelationRequestTargetResponseStatusModel from '@/models/services/network/RelationRequestTargetResponseStatusModel';
import RelationRequestTargetResponseListRow     from './RelationRequestTargetResponseListRow';
import ContactModel                             from '@/models/services/network/ContactModel';
import { ModalData }                            from '@/components/modal/Modal';
import usePagedCollection                       from '@widesk-core/hooks/usePagedCollection';
import useApiCollection                         from '@widesk-core/hooks/useApiCollection';
import authStore                                from '@/stores/authStore';
import PagedCollection                          from '@widesk-core/models/PagedCollection';
import React                                    from 'react';

interface IRelationRequestTargetResponseListBoxProps {
	setModalData: React.Dispatch<React.SetStateAction<ModalData | undefined>>;
	setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	fetchRef?: React.MutableRefObject<(() => Promise<void>) | undefined>
	onListSuccess?: (collection: PagedCollection<RelationRequestTargetResponseModel>) => void;
	options?: {
		withPagination?: boolean,
		bottomLink?: {
			label: string;
			to: string;
		};
	}
}

const RelationRequestTargetResponseListBox = (props: IRelationRequestTargetResponseListBoxProps) => {
	
	const contactCollection = usePagedCollection(ContactModel);
	const relationRequestTargetResponseCollection = usePagedCollection(RelationRequestTargetResponseModel);
	const relationRequestTargetResponseStatusCollection = useApiCollection(RelationRequestTargetResponseStatusModel);

	const { setModalData, setModalIsOpen, fetchRef, onListSuccess, options } = props;

	const { t } = useTranslation();

	React.useEffect(() => {
		if (onListSuccess) {
			onListSuccess(relationRequestTargetResponseCollection);
		}
	}, [relationRequestTargetResponseCollection.total])

	return (
		<List
			afterFetch={() => {
				if (onListSuccess) {
					onListSuccess(relationRequestTargetResponseCollection);
				}
			}}
			beforeFetch={async () => {
				await Promise.all([
					contactCollection.setSort('firstname', 'asc').listBy([authStore.currentUser.urn], 'ownerUser.userUrn'),
					relationRequestTargetResponseStatusCollection.list(),
				]);
				const pendingId = relationRequestTargetResponseStatusCollection.find(m => m.reference === 'pending')?.id
				relationRequestTargetResponseCollection.setRequiredFilter('relationRequestTargetResponseStatus', pendingId);
			}}
			collection={relationRequestTargetResponseCollection}
			renderRow={(relationRequestTargetResponse) => (
				<RelationRequestTargetResponseListRow 
					contactCollection={contactCollection}
					relationRequestTargetResponse={relationRequestTargetResponse}
					relationRequestTargetResponseCollection={relationRequestTargetResponseCollection}
					relationRequestTargetResponseStatusCollection={relationRequestTargetResponseStatusCollection}
					setModalData={setModalData}
					setModalIsOpen={setModalIsOpen}
				/>
			)}
			getFetch={fetch => {
				if (fetchRef) {
					fetchRef.current = fetch;
				}
			}}
			options={{
				emptyMessages: {
					title: t('pages.contacts.list.emptyPendingContacts.title'),
					description: t('pages.contacts.list.emptyPendingContacts.description'),
					icon: <ContactsIcon size="xl" />,
				},
				itemsMargin: '10px 0px 10px 0px',
				itemsPadding: '10px',
				padding: '0px 10px 0px 10px',
				withSeparators: true,
				withPagination: options?.withPagination,
				bottomLink: options?.bottomLink
			}}
		/>
	);
}

export default RelationRequestTargetResponseListBox;